import { $, _ } from "../../../../helpers/dom-selectors.js";
import makeForms from "../../../global-components/forms/forms.js";
import makeReOrderModal from "../../../global-components/forms/re-order-modal.js";
import APP_EVENTS from "../init/events.js";
const forms = $(document, '.form');
const serviceForms = makeForms({
    forms,
    overlayEl: _('resultOverlay'),
    entity: 'Service',
    events: APP_EVENTS,
    action: 'add-service-clicked'
});
const reOrderModal = makeReOrderModal({
    overlayEl: _('resultOverlay'),
    entity: 'Service'
});
const APP_COMPONENTS = Object.freeze({
    serviceForms,
    reOrderModal
});
export default APP_COMPONENTS;
